import React, { useState, useEffect, useRef } from "react";
import "./Music.css";

const Music = () => {
	const [imageOne, setImageOne] = useState(500);
	const [imagetwo, setImagetwo] = useState(500);
	const [imagethree, setImagethree] = useState(500);
	const img1Ref = useRef(null);
	const img2Ref = useRef(null);
	const img3Ref = useRef(null);
	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".musicDiv");
			const textEl = document.querySelector(".musicText");

			if (
				!el ||
				!textEl ||
				!img1Ref.current ||
				!img2Ref.current ||
				!img3Ref.current
			)
				return;

			const screenBottom = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;

			if (elPos < screenBottom && elPos + 150 > 0) {
				textEl.style.visibility = "visible";
				textEl.style.opacity = "1";
				textEl.style.transform = "translateX(0)";
			} else {
				textEl.style.visibility = "hidden";
				textEl.style.opacity = "0";
				textEl.style.transform = "translateX(-300px)";
			}

			const updateImage = (rect, setter) => {
				setter(rect.bottom - 50 < screenBottom ? 0 : 500);
			};

			updateImage(img1Ref.current.getBoundingClientRect(), setImageOne);
			updateImage(img2Ref.current.getBoundingClientRect(), setImagetwo);
			updateImage(img3Ref.current.getBoundingClientRect(), setImagethree);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);
	return (
		<div className='music'>
			<div className='musicText'>
				<h2>Das perfekte Erlebnis-Geschenk</h2>
				{/* <h3>Front-End Developer • Created with HTML/CSS</h3> */}
				<p>
					Schenke Emotionen, Adrenalin und einen himmlischen Moment voller
					Freiheit.
				</p>
				{/* <a
          href="https://semko1010.github.io/musikProject/assets/html/inspiration.html"
          target="_blank"
          rel="noreferrer"
          className="music-flip"
          data-back="Music Beyond"
          data-front="Show Me"
        ></a> */}
				<ul>
					<li>Gutschein ohne festen Termin</li>
					<li>Emotionales Highlight für Geburtstage & Jubiläen</li>
					<li>Professionelle Einweisung & ruhige Atmosphäre</li>
					<li>Auf Wunsch mit Videoaufnahme</li>
				</ul>
			</div>
			<img
				ref={img1Ref}
				style={{ transform: `translateX(${imageOne}%)` }}
				id='img1'
				src='./img/music/image1.jpg'
				alt=''
				className='image1'
			/>
			<img
				ref={img2Ref}
				style={{ transform: `translateX(${imagetwo}%)` }}
				id='img2'
				src='./img/music/image2.jpg'
				alt=''
				className='image2'
			/>
			<img
				ref={img3Ref}
				style={{ transform: `translateX(${imagethree}%)` }}
				id='img3'
				src='./img/music/image3.jpg'
				alt=''
				className='image3'
			/>
		</div>
	);
};

export default Music;
